<div class="position-relative text-grey">
  <div class="modal-header">
    <h4 class="modal-title synchpc-primary" id="modal-title">
      Connect Workstation
    </h4>
    <i
      style="z-index: 1"
      class="bi bi-x-lg text-danger"
      color="warn"
      (click)="onCancel()"
      title="Close"
    ></i>
  </div>
  <div class="modal-body" style="padding: 7px">
    <form action="" [formGroup]="dynamicWsForm">
      <mat-form-field style="width: 48%">
        <mat-label>Select Deployment</mat-label>
        <mat-select
          formControlName="deploymentName"
          (selectionChange)="getNodeGroupsForDeployments()"
        >
          <mat-option *ngFor="let dep of depName" value="{{ dep }}">
            {{ dep }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field style="width: 48%">
        <mat-label>Select NodeGroup</mat-label>
        <mat-select formControlName="nodeGroup">
          <mat-option
            *ngFor="let group of nodeGroupsOfDeployment"
            value="{{ group }}"
          >
            {{ group }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field style="width: 48%">
        <mat-label>Select Application</mat-label>
        <mat-select
          formControlName="applicationName"
          (selectionChange)="getApplicationVersion()"
        >
          <mat-option value="-1">None</mat-option>
          <mat-option *ngFor="let app of applicationNames" value="{{ app }}">
            {{ app }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field style="width: 48%">
        <mat-label>Select Application Version</mat-label>
        <mat-select formControlName="applicationVersion">
          <mat-option value="-1">None</mat-option>
          <mat-option
            *ngFor="let version of appVersionList"
            value="{{ version.appVersionValue }}"
          >
            {{ version.appVersionText }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field style="width: 48%">
        <mat-label>Enter Cpu Cores</mat-label>
        <mat-select formControlName="cpuCores">
          <mat-option value="-1">Any</mat-option>
          <mat-option *ngFor="let core of cores" value="{{ core }}">
            {{ core }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field style="width: 48%">
        <mat-label>Select Gpu</mat-label>
        <mat-select formControlName="gpuName">
          <mat-option value="-1">Any</mat-option>
          <mat-option *ngFor="let gpu of gpuNames" value="{{ gpu }}">
            {{ gpu }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field style="width: 48%">
        <mat-label>Select Ram</mat-label>
        <mat-select formControlName="ram">
          <mat-option value="-1">Any</mat-option>
          <mat-option *ngFor="let ram of availableRam" value="{{ ram }}">
            {{ ram | fileSize }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field style="width: 48%">
        <mat-label>Select Platform</mat-label>
        <mat-select formControlName="platform">
          <mat-option value="-1">Any</mat-option>
          <mat-option *ngFor="let os of platform" value="{{ os }}">
            {{ os }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field *ngIf="showSelectDuration" style="width: 48%">
        <mat-label>Select Duration</mat-label>
        <mat-select formControlName="duration">
          <mat-option value="-1">None</mat-option>
          <mat-option *ngFor="let hrs of timeDuration" value="{{ hrs }}">
            {{ hrs }} hrs
          </mat-option>
        </mat-select>
      </mat-form-field>
    </form>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-outline-secondary"
      (click)="onCancel()"
    >
      Cancel
    </button>
    <button
      type="button"
      class="btn btn-primary"
      (click)="onSubmit()"
      cdkFocusInitial
    >
      Connect
    </button>
  </div>
  <ngx-spinner
    bdColor="rgba(0,0,0,0)"
    size="default"
    zIndex="1"
    color="var(--s-primary-color)"
    type="ball-spin"
    [fullScreen]="false"
    name="connectWs"
  ></ngx-spinner>
</div>
